"use client"

import { useState, useMemo } from "react"
import type { TreeNode } from "../../file-tree-manager/types/tree-types"
import { searchNodes } from "../../file-tree-manager/utils/search-utils"
import { sortSearchResults } from "../../file-tree-manager/utils/sort-utils"

export const useSearch = (treeData: TreeNode[]) => {
  const [searchTerm, setSearchTerm] = useState("")

  const filteredData = useMemo(() => {
    const searchResults = searchNodes(treeData, searchTerm)
    return sortSearchResults(searchResults)
  }, [treeData, searchTerm])

  const clearSearch = () => {
    setSearchTerm("")
  }

  return {
    searchTerm,
    setSearchTerm,
    filteredData,
    clearSearch,
    isSearching: searchTerm.trim().length > 0,
  }
}


